import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueHierarchyRedirectRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-hierarchy-redirect',
	path: '/secure/PortfolioHierarchy.jspa',
};
